import { Menubar } from 'primereact/menubar';

const BaseNavBar = (props) => {
    return (
        <Menubar {...props} className={`${props.custom ? props.custom : ""} ${props.extra ? props.extra : ""}`}/>
    );
}

export default BaseNavBar;